{
  "notFound": {
    "title": "Page not found",
    "description": "Sorry, the page you're looking for doesn't exist."
  },
  "fatalError": {
    "title": "Application configuration failed.",
    "description": "Please try refreshing the page."
  },
  "buttons": {
    "back": "Back",
    "cancel": "Cancel",
    "validate": "Validate"
  },
  "profile": {
    "title": "Profile",
    "subtitle": "Profile info",
    "logout": "Logout",
    "language": "Language",
    "settings": "Settings",
    "administration": "Administration",
    "userManagement": "User management",
    "selectLanguage": "Select language",
    "logoutDialog": {
      "title": "Log out?",
      "description": "All your reports will be saved and retrievable when you log in again"
    },
    "personalInformation": {
      "title": "Personal information",
      "fields": {
        "lastName": "Last name",
        "firstName": "First name",
        "email": "Email",
        "country": "Country",
        "organization": "Organization"
      }
    }
  },
  "board": {
    "title": "Global wildlife health"
  },
  "navigation": {
    "board": "Board",
    "myReports": "My Reports",
    "addReport": "Add Report",
    "resources": "Resources",
    "alerts": "Alerts",
    "userManagement": "User management",
    "profile": "Profile",
    "appTitle": "WildEpi",
    "map": "Map",
    "list": "List"
  },
  "alerts": {
    "markAllAsRead": "Mark all as read",
    "updateOnReport": "Update on report",
    "reportUpdated": "{{reportCode}} has been updated",
    "savedOnReport": "Report saved",
    "reportSaved": "{{reportCode}} has been saved",
    "rraRequestedOnReport": "RRA request on report",
    "reportRraRequested": "An RRA was requested for {{reportCode}}",
    "rraCompletedOnReport": "RRA completed on report",
    "reportRraCompleted": "RRA is completed for {{reportCode}}",
    "draftOnReport": "Draft on report",
    "reportDraft": "{{reportCode}} has been saved as draft",
    "emptyTitle": "No alerts for now"
  },
  "resources": {
    "learningMaterial": "Learning material",
    "helpAndSupport": "Help and support",
    "trainingVideos": "Training videos",
    "about": "About",
    "faqs": "FAQs",
    "reportBug": "Report bug or issue"
  },
  "app": {
    "name": "WildEpi"
  },
  "login": {
    "sso": "Log in with SSO",
    "welcome": "Welcome to WildEpi"
  },
  "auth": {
    "userLoadError": {
      "title": "We couldn't load your profile",
      "description": "Please try again to continue using the app."
    },
    "retry": "Retry",
    "loadingProfile": "Loading your profile..."
  },
  "offlineMode": {
    "banner": "You are offline. Only report creation is available."
  },
  "noData": "No data available",
  "reportCreation": {
    "title": "Create a report",
    "editTitle": "Edit a report",
    "backToReport": "Back to report",
    "steps": {
      "generalInformation": "General Information",
      "surveillanceAndEtiology": "Surveillance and Etiology",
      "diagnosticProcedure": "Diagnostic Procedure",
      "supportingDocuments": "Supporting Documents"
    },
    "buttons": {
      "saveAsDraft": "Save as draft",
      "deleteDraft": "Delete Draft",
      "next": "Next",
      "save": "Save",
      "publish": "Publish"
    },
    "success": {
      "title": "Your report has been published",
      "subtitle": "Edit it anytime and find it again in My Reports.",
      "validateButton": "Validate",
      "draftTitle": "Your report has been saved as a draft",
      "draftSubtitle": "This report has been saved as a draft. You can find it in your reports list.",
      "queuedTitle": "Your report is waiting to be synchronized",
      "queuedSubtitle": "We will submit it automatically as soon as the connection is available.",
      "csvImportPublishedTitle": "Your reports are being synchronized",
      "csvImportPublishedSubtitle": "They will appear in My Reports once synchronization is complete.",
      "csvImportDraftTitle": "Your reports are being synchronized",
      "csvImportDraftSubtitle": "Valid rows will be published. Invalid rows will be saved as drafts so you can finalize them later.",
      "csvImportResultTitle": "CSV import completed",
      "csvImportResultSubtitle": "Summary of your imported reports.",
      "csvImportResultPublished": "{{count}} published report(s)",
      "csvImportResultDraft": "{{count}} draft report(s)",
      "csvImportResultError": "{{count}} report(s) in error"
    },
    "toasts": {
      "submitError": "Something went wrong while saving the report. Please try again.",
      "uploadSupportingDocumentsError": "Something went wrong while uploading the supporting documents. Please try again.",
      "similarReportsMissingLocation": "Please provide valid coordinates before publishing.",
      "similarReportsError": "We couldn't check for similar reports. Please try again.",
      "offlineQueueAdded": "Report added to the offline submission queue.",
      "offlineQueueProcessed": "Pending reports were synchronized."
    },
    "similarReports": {
      "title": "Validate report",
      "heading": "We found similar reports",
      "subheading": "Please check the following reports before publishing."
    },
    "versionNote": {
      "title": "Add version note",
      "heading": "Add version note",
      "fieldLabel": "Version note",
      "placeholder": "Describe reason for editing"
    },
    "deleteDraftDialog": {
      "title": "Delete draft?",
      "description": "This draft will be discarded and all entered information will be lost.",
      "confirm": "Delete draft"
    },
    "creationModeModal": {
      "title": "Add report",
      "description": "Choose a type of report creation",
      "inAppForm": "In-app form",
      "csvImport": "CSV import"
    },
    "csvImportModal": {
      "title": "CSV import",
      "dropzoneTitle": "Tap to add a file",
      "dropzoneSubtitle": "CSV format (15 MB max.)",
      "back": "Back",
      "import": "Import",
      "saveAsDraft": "Save as draft",
      "publish": "Publish",
      "downloadTemplate": "Download template"
    },
    "csvImportValidation": {
      "file": "File",
      "errorRowLabel": "Row {{rowNumber}} - {{columnHeader}}",
      "summary": {
        "valid": "Validation successful. {{totalRows}} row(s) ready for import.",
        "invalid": "Validation failed. {{validRows}} valid / {{invalidRows}} invalid row(s) on {{totalRows}}."
      },
      "errors": {
        "noFileSelected": "Please select a CSV file before importing.",
        "unableToReadFile": "Unable to read the selected file.",
        "emptyFile": "The CSV file is empty.",
        "noDataRows": "No data rows found. Add at least one report row.",
        "missingColumn": "Missing column in CSV header.",
        "unexpectedColumn": "Unexpected column in CSV header.",
        "requiredField": "This field is required.",
        "invalidOption": "Value does not match allowed values.",
        "invalidDynamicOption": "Value does not match allowed values for specified parent.",
        "invalidDate": "Invalid date. Expected format: YYYY-MM-DD or DD/MM/YYYY.",
        "invalidNumber": "Invalid number.",
        "numberBelowZero": "Value must be greater than or equal to 0.",
        "populationMustBeAboveZero": "Population size must be greater than 0.",
        "invalidLatitude": "Latitude must be between -90 and 90.",
        "invalidLongitude": "Longitude must be between -180 and 180.",
        "totalCountTooLow": "Total tests must be at least positive + negative tests.",
        "textTooLong": "Text exceeds maximum length ({{count}} characters)."
      }
    },
    "csvTemplate": {
      "diagnosticPrefix": "Diagnostic",
      "hints": {
        "dynamicOptionExactMatch": "Select a value from the app list (text must match exactly).",
        "species": "Enter the scientific name of the species (exact name).",
        "yesNo": "Yes | No",
        "date": "Date format: YYYY-MM-DD",
        "nonNegativeNumber": "Number >= 0",
        "populationSize": "Number > 0 and at least equal to dead + sick.",
        "totalCount": "Number >= positive tests + negative tests.",
        "maxCharacters_one": "Free text (max {{count}} character).",
        "maxCharacters_other": "Free text (max {{count}} characters).",
        "freeText": "Free text",
        "latitude": "Decimal latitude (WGS84).",
        "longitude": "Decimal longitude (WGS84)."
      }
    },
    "errors": {
      "requiredField": "This field is required",
      "countryForbidden": "You cannot create reports in this country.",
      "noCountryCoordinates": "No country is associated with these coordinates.",
      "futureDetectionDate": "The date of detection cannot be in the future.",
      "populationMustBeGreaterThanZero": "Population size must be greater than 0.",
      "populationTooSmall": "Population size must be at least the sum of dead and sick individuals.",
      "testsMustBeNonNegative": "Test counts must be 0 or greater.",
      "testsGreaterThanPopulation": "The number of tests cannot exceed the population size.",
      "totalTestsTooLow": "Total number of tests must be at least the sum of positive and negative results.",
      "totalTestsMustBeGreaterThanZero": "Total number of tests must be greater than 0.",
      "wahisAgentInWahis": "This etiological agent must be reported through the WAHIS app."
    },
    "common": {
      "characterLimit": "{{currentLength}}/{{maxLength}} characters max",
      "noResults": "No results found",
      "useCustomValue": "Use \"{{value}}\" as a custom value"
    },
    "step1": {
      "sections": {
        "animalDescription": "Animal description",
        "location": "Location - WGS84",
        "dateOfDetection": "Date of detection"
      },
      "fields": {
        "animalType": "Animal type",
        "species": "Species",
        "wildtype": "Wild type",
        "location": "Location",
        "dateOfDetection": "Date of detection",
        "inaccurateLocation": "Approximate location"
      },
      "placeholders": {
        "selectSpecies": "Select species or group",
        "speciesFreeText": "Enter a species",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "dateFormat": "DD/MM/YYYY"
      },
      "options": {
        "animalType": {
          "vertebrate": "Vertebrate",
          "invertebrate": "Invertebrate"
        },
        "wildtype": {
          "freeRoaming": "Free-roaming",
          "captive": "Captive",
          "feral": "Feral"
        },
        "species": {
          "canisLupus": "Canis lupus",
          "bosTaurus": "Bos taurus",
          "susScrofa": "Sus scrofa",
          "anasPlatyrhynchos": "Anas platyrhynchos",
          "apisMellifera": "Apis mellifera"
        }
      }
    },
    "step2": {
      "sections": {
        "surveillance": "Surveillance",
        "etiology": "Etiology"
      },
      "fields": {
        "surveillanceType": "Surveillance type",
        "description": "Description",
        "numberOfDeaths": "Number of dead individuals",
        "numberOfSick": "Number of sick individuals",
        "populationSize": "Population size (if known)",
        "humanAffected": "Human affected",
        "domesticAnimalAffected": "Domestic animal affected",
        "knowTheCause": "Do you know the cause?",
        "etiologyType": "Etiology type",
        "etiologyAgent": "Etiological agent",
        "diagnosticProcedure": "Diagnostic procedure"
      },
      "placeholders": {
        "describeSurveillance": "Describe surveillance",
        "selectEtiologyType": "Select etiology type",
        "selectEtiologyAgent": "Select etiological agent"
      },
      "options": {
        "surveillanceType": {
          "active": "Active",
          "passive": "Passive",
          "other": "Other",
          "unknown": "Unknown"
        },
        "yesNoUnknown": {
          "yes": "Yes",
          "no": "No",
          "iDontKnow": "I don't know"
        },
        "yesNo": {
          "yes": "Yes",
          "no": "No"
        },
        "diagnosticProcedure": {
          "yes": "Yes",
          "no": "No"
        }
      },
      "helpers": {
        "etiologyAgentHint": "If your agent is not in the list please type it down here to add it"
      },
      "warnings": {
        "massMortality": "Warning message: reporting a mass mortality or morbidity event. Is the number of affected animals correct?"
      }
    },
    "step3": {
      "diagnosticProcedureTitle": "Diagnostic procedure",
      "sections": {
        "sampling": "Sampling",
        "tests": "Tests",
        "results": "Results"
      },
      "fields": {
        "sampleType": "Type of sample",
        "category": "Category",
        "subcategory": "Subcategory",
        "family": "Family",
        "positiveCount": "Number of positive tests",
        "negativeCount": "Number of negative tests",
        "totalCount": "Total number of tests",
        "extraTestInfo": "Extra test info"
      },
      "placeholders": {
        "sampleType": "Search sample type",
        "subcategory": "Select subcategory",
        "family": "Select family",
        "extraTestInfo": "Describe test info"
      },
      "options": {
        "category": {
          "direct": "Direct",
          "indirect": "Indirect",
          "observation": "Observation",
          "others": "Others"
        },
        "subcategory": {
          "pcr": "PCR test",
          "microscopy": "Microscopy",
          "serology": "Serology",
          "fieldObservation": "Field observation"
        },
        "family": {
          "viralIsolation": "Viral isolation",
          "genomicSequencing": "Genomic sequencing",
          "elisa": "ELISA",
          "rapidTest": "Rapid test"
        }
      },
      "actions": {
        "addProcedure": "Add test",
        "addButtonSectionTitle": "Did you conduct additional tests?",
        "deleteProcedure": "Delete test"
      }
    },
    "step4": {
      "sections": {
        "attachments": "Attachments"
      },
      "fields": {
        "attachDocuments": "Attach documents"
      },
      "helpers": {
        "tapToAddFile": "Tap to add a file",
        "fileFormats": "PDF, DOCX, CSV, PNG, TXT or JPEG format (15 MB max.)"
      },
      "errors": {
        "unsupportedFormat": "Some files were not added because the format is not supported.",
        "sizeExceeded": "Some files exceed the 15 MB limit and were skipped."
      }
    }
  },
  "reportDetail": {
    "title": "Report details",
    "header": {
      "author": "Author",
      "creationDate": "Creation date",
      "country": "Country",
      "version": "Version"
    },
    "sections": {
      "generalInformation": "General information",
      "surveillanceAndEtiology": "Surveillance and etiology",
      "diagnosticProcedure": "Diagnostic procedure",
      "supportingDocuments": "Supporting documents",
      "rapidRiskAssessment": "Rapid Risk Assessment (RRA)"
    },
    "fields": {
      "speciesAndOrder": "Species and order",
      "locationCoordinates": "Location (latitude / longitude)",
      "locationAccuracyFlag": "Location accuracy flag"
    },
    "missingIndicator": "To be completed",
    "diagnosticProcedureLabel": "Diagnostic procedure {{index}}",
    "supportingDocuments": {
      "empty": "No supporting documents.",
      "fileType": "Type",
      "fileSize": "Size",
      "uploadDate": "Upload date"
    },
    "toasts": {
      "openSupportingDocumentError": "Unable to open the supporting document. Please try again.",
      "loadVersionsError": "Unable to load report versions. Please try again.",
      "shareError": "Unable to share this report link. Please try again.",
      "copyShareUrlSuccess": "Report link copied.",
      "copyShareUrlError": "Unable to copy this report link. Please try again.",
      "requestRraError": "Unable to request an RRA. Please try again.",
      "uploadRraError": "Unable to upload the RRA document. Please try again."
    },
    "versions": {
      "title": "Report versions",
      "versionLabel": "v. {{version}}"
    },
    "actions": {
      "edit": "Edit",
      "delete": "Delete",
      "requestRra": "Request RRA",
      "uploadRra": "Upload RRA",
      "download": "Download",
      "open": "Open",
      "share": "Share",
      "copyShareUrl": "Copy report link"
    },
    "share": {
      "title": "Share report"
    },
    "deleteDialog": {
      "title": "Delete report?",
      "description": "This report will be removed from your reports list."
    },
    "rra": {
      "pendingState": "Pending RRA",
      "pendingDescription": "File will be visible here when published",
      "pdfLabel": "RRA document",
      "versionNote": "RRA document uploaded"
    },
    "rraRequestSuccess": {
      "title": "Your Rapid Risk Assessment request has been sent",
      "subtitle": "Once the status has been updated, you can view the Risk Assessment PDF in the report details.",
      "validateButton": "Go to report"
    },
    "values": {
      "yes": "Yes",
      "no": "No",
      "dontKnow": "Don't know"
    }
  },
  "speciesSearch": {
    "title": "Species",
    "searchPlaceholder": "Search species or taxonomic group",
    "actions": {
      "taxonomyTree": "Taxonomy tree",
      "identifyWithAi": "Identify with AI"
    },
    "results": {
      "title": "Search results"
    },
    "empty": {
      "noResults": "No results",
      "promptTitle": "Search for a species",
      "promptDescription": "Start typing to see matching species or taxonomic groups."
    },
    "ai": {
      "title": "Identify with AI",
      "imagePreviewTitle": "Image preview",
      "previewDescription": "We'll use this file to identify the species.",
      "processingTitle": "Analyzing species...",
      "processingDescription": "Please wait a few seconds while we analyze your file.",
      "noResultsTitle": "No matches found",
      "noResultsDescription": "We couldn't identify the species from this file.",
      "matchesTitle": "We found {{count}} matching species",
      "matchesSubtitle": "Select a species to continue",
      "bestMatch": "Best match",
      "otherMatches": "Other matches",
      "wrongGuess": "Wrong guess?",
      "trySearch": "Try a search",
      "emptyTitle": "No matches yet",
      "emptyDescription": "Capture or upload an image to identify species."
    },
    "modals": {
      "addFileTitle": "Add file",
      "photoLibrary": "Photo library",
      "takePhoto": "Take photo",
      "chooseFile": "Choose file"
    },
    "taxonomy": {
      "title": "Taxonomy tree",
      "select": "Select {{level}}",
      "helperPrefix": "Don't know?",
      "helperSearch": "Try a search",
      "helperConnector": "or",
      "stopIdentification": "stop identification",
      "loading": "Loading taxonomy...",
      "noResults": "No taxonomy results.",
      "noResultsForSelection": "No results for \"{{label}}\".",
      "emptyTitle": "No taxonomy data yet",
      "emptyDescription": "The taxonomy tree will appear here.",
      "unassigned": "Unassigned"
    }
  },
  "reports": {
    "count": "{{count}} reports",
    "emptyStateDescription": "Once you submit a report, it will appear here.",
    "emptyStateTitle": "No reports yet",
    "individuals": "individuals",
    "action": {
      "viewMore": "View more"
    },
    "loadingMore": "Loading more reports...",
    "exportCsv": "Export",
    "csvExport": {
      "headers": {
        "reportCode": "Report code",
        "versionNumber": "Version number",
        "userCountry": "User country",
        "userOrganization": "User organization",
        "assets": "Assets",
        "diagnosticSampleType": "Diagnostic {{index}} - Sample type",
        "diagnosticSubcategory": "Diagnostic {{index}} - Subcategory",
        "diagnosticCategoryOfTest": "Diagnostic {{index}} - Category of test",
        "diagnosticFamily": "Diagnostic {{index}} - Family",
        "diagnosticExtraTestInformation": "Diagnostic {{index}} - Extra test information",
        "diagnosticNumberOfNegativeTests": "Diagnostic {{index}} - Number of negative tests",
        "diagnosticNumberOfPositiveTests": "Diagnostic {{index}} - Number of positive tests",
        "diagnosticNumberOfTests": "Diagnostic {{index}} - Number of tests"
      }
    },
    "pageSize": "Items per page",
    "sort": {
      "none": "No sorting",
      "placeholder": "Sort by",
      "order": "Change sort order"
    },
    "columns": {
      "species": "Species",
      "disease": "Disease",
      "individualsAffected": "Individuals affected",
      "dateOfDetection": "Date of detection",
      "location": "Location",
      "status": "Status"
    }
  },
  "filters": {
    "title": "Filters",
    "apply": "Apply",
    "clear": "Clear",
    "close": "Close filters",
    "open": "Filter",
    "sections": {
      "generalInformation": "General information",
      "animal": "Animal",
      "surveillanceAndEtiology": "Surveillance and etiology",
      "diagnosticProcedure": "Diagnostic procedure"
    },
    "fields": {
      "reportName": "Report name",
      "status": "Status",
      "country": "Country",
      "region": "Region",
      "dateOfDetection": "Date of detection",
      "animalType": "Type",
      "order": "Order",
      "species": "Species",
      "wildType": "Wild type",
      "surveillanceType": "Surveillance type",
      "knownCause": "Knowledge of cause",
      "etiologyType": "Type of etiology",
      "etiologicalAgent": "Etiological agent",
      "diagnosticProcedure": "Diagnostic procedure",
      "sampleType": "Type of sample",
      "categoryOfTest": "Type of test"
    },
    "placeholders": {
      "reportName": "All report names",
      "status": "All status",
      "country": "All countries",
      "region": "All regions",
      "dateRange": "All dates",
      "order": "All orders",
      "species": "All species",
      "wildType": "All wild types",
      "surveillanceType": "All types",
      "etiologyType": "All types",
      "etiologicalAgent": "All agents",
      "sampleType": "All types",
      "categoryOfTest": "All types"
    },
    "options": {
      "all": "All",
      "status": {
        "published": "Published",
        "pendingRra": "Pending RRA",
        "publishedRra": "Published RRA",
        "draft": "Draft",
        "incorrect": "Incorrect"
      }
    },
    "dateRange": {
      "start": "Start",
      "end": "End",
      "today": "Today"
    }
  },
  "pinPosition": {
    "selectLocation": "Select location",
    "longitude": "Longitude",
    "latitude": "Latitude",
    "modalTitle": "Animal/sample location",
    "coordinatesTitle": "WGS84 coordinates"
  },
  "userManagement": {
    "title": "User management",
    "actions": {
      "add": "Add user",
      "edit": "Edit",
      "delete": "Delete",
      "deactivate": "Deactivate user",
      "save": "Save"
    },
    "columns": {
      "name": "Name",
      "firstName": "First name",
      "lastName": "Last name",
      "email": "Email",
      "country": "Country",
      "organization": "Organization",
      "role": "Role",
      "status": "Status",
      "creationDate": "Creation date",
      "actions": "Actions"
    },
    "filters": {
      "allCountries": "All countries",
      "allRoles": "All roles",
      "allStatuses": "All statuses",
      "country": "Country",
      "role": "Role",
      "status": "Status"
    },
    "search": {
      "label": "Search",
      "placeholder": "Search by name or email"
    },
    "roles": {
      "basic": "Basic",
      "validated": "Validated",
      "focalPoint": "Focal point",
      "delegate": "Delegate",
      "referenceCenter": "Reference center",
      "adminViewOnly": "Admin (view only)",
      "admin": "Admin"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "form": {
      "fullName": "Full name",
      "firstName": "First name",
      "lastName": "Last name",
      "organization": "Organization",
      "email": "Email",
      "country": "Country",
      "role": "Role",
      "fullNamePlaceholder": "Enter full name",
      "firstNamePlaceholder": "Enter first name",
      "lastNamePlaceholder": "Enter last name",
      "organizationPlaceholder": "Enter organization",
      "emailPlaceholder": "Enter email address",
      "countryPlaceholder": "Select country",
      "rolePlaceholder": "Select role"
    },
    "errors": {
      "required": "This field is required",
      "email": "Enter a valid email address"
    },
    "modal": {
      "createTitle": "Add user",
      "editTitle": "Edit user",
      "createDescription": "Fill in the information below.",
      "editDescription": "Update the user details below.",
      "discardTitle": "Discard changes?",
      "discardDescription": "Your changes will be lost.",
      "discard": "Discard"
    },
    "deleteDialog": {
      "title": "Deactivate user?",
      "description": "This will deactivate the user and remove their access."
    },
    "empty": {
      "list": "No users found.",
      "country": "No country",
      "date": "No date"
    },
    "loading": "Loading users...",
    "noAccess": {
      "title": "Access restricted",
      "description": "You do not have permission to view user management."
    }
  }
}
